import { render } from "./VideoCollection.vue?vue&type=template&id=6a21077a&scoped=true"
import script from "./VideoCollection.vue?vue&type=script&lang=js"
export * from "./VideoCollection.vue?vue&type=script&lang=js"

import "./VideoCollection.vue?vue&type=style&index=0&id=6a21077a&scoped=true&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a21077a"]])

export default __exports__